"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewGaiaMessage extends new_item_1.default {
    constructor(newGaiaMessage) {
        super();
        this.role = newGaiaMessage.role;
        this.content = newGaiaMessage.content;
        this.conversationId = newGaiaMessage.conversationId;
        this.createdAt = newGaiaMessage.createdAt;
    }
}
exports.default = NewGaiaMessage;
//# sourceMappingURL=new-gaiaMessage.js.map